import { useState, useCallback, useRef } from "react"
import ContentEditable from "react-contenteditable"
import { debounce } from "ts-debounce"
import useDidUpdateEffect from "~/hooks/useDidUpdateEffect"

const Notes = ({ initialNotes, onPersist }) => {
  const ref = useRef(null)
  const [notes, setNotes] = useState(initialNotes)

  const debouncedPersist = useCallback(debounce(onPersist, 500), [])

  useDidUpdateEffect(() => {
    debouncedPersist(notes)
  }, [notes])

  if (notes === null) {
    return (
      <div className="mt-4">
        <a className="link" onClick={() => setNotes("")}>
          + Add notes
        </a>
      </div>
    )
  }

  return (
    <div className="mt-4 space-y-1 border-l-4 border-sapphire pl-4">
      <div className="mb-2 text-lg font-semibold">Notes</div>

      <ContentEditable
        innerRef={ref}
        html={notes}
        onChange={(event) => {
          setNotes(event.target.value)
        }}
        className={`w-full rounded bg-warning/20 p-3 shadow-inner shadow-fg-muted/20 focus:outline-none`}
      />
    </div>
  )
}

export default Notes
